import React from 'react'
import { Navigate, Route, Routes, useRoutes } from 'react-router-dom'
import LandingSignupPage from './SignUpPage'
import PrivacyPolicy from '../legal/PrivacyPolicy'
import { Box } from '@mui/material'
import TermsOfUse from '../legal/TermsOfUse'
import SubscriptionAgreementDocument from '../legal/SubscriptionAgreementDocument'
import Verify from './Verify'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const SignUpRoutes = () =>
  useRoutes([
    {
      path: '/',
      element: (
        <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
          <LandingSignupPage />
        </GoogleReCaptchaProvider>
      ),
    },
    { path: '/privacy-policy', element: <PrivacyPolicy /> },
    { path: '/terms-of-use', element: <TermsOfUse /> },
    // The Business Subscription Agreement accepted on the payment step. With
    // no version the server returns the current one; the payment step links
    // to the exact version named in the Plan Summary.
    {
      path: '/subscription-agreement',
      element: <SubscriptionAgreementDocument />,
    },
    {
      path: '/subscription-agreement/:version',
      element: <SubscriptionAgreementDocument />,
    },
    { path: '/verify', element: <Verify /> },
    { path: '*', element: <Navigate to="/" replace /> },
  ])

const SignUp = () => {
  return (
    <Box>
      <Routes>
        <Route path="/*" element={<SignUpRoutes />} />
      </Routes>
    </Box>
  )
}

export default SignUp
